const kn = {
  nav: {
    login: 'ಲಾಗಿನ್',
    bookNow: 'ಈಗಲೇ ಬುಕ್ ಮಾಡಿ',
    dashboard: 'ಡ್ಯಾಶ್‌ಬೋರ್ಡ್',
    back: 'ಹಿಂದೆ',
    home: 'ಮುಖಪುಟ',
  },
  landing: {
    heroTitle1: 'ಆಕಾಶ ಪ್ರಯಾಣಗಳು,',
    heroTitle2: 'ಈಗ ಸುಲಭ',
    heroSubtitle: 'ಭಾರತದ ಪ್ರಮುಖ ಹೆಲಿಕಾಪ್ಟರ್ ಚಾರ್ಟರ್ ಅಗ್ರಿಗೇಟರ್. ಪರಿಶೀಲಿಸಿದ ಆಪರೇಟರ್‌ಗಳೊಂದಿಗೆ ಸಂಪರ್ಕ ಸಾಧಿಸಿ, ತಕ್ಷಣ ವಿಮಾನಗಳನ್ನು ಬುಕ್ ಮಾಡಿ.',
    bookYourFlight: 'ನಿಮ್ಮ ವಿಮಾನವನ್ನು ಬುಕ್ ಮಾಡಿ',
    becomeOperator: 'ಆಪರೇಟರ್ ಆಗಿ',
    whyChoose: 'AirYatra ಏಕೆ ಆಯ್ಕೆ ಮಾಡಬೇಕು?',
    verifiedOperators: 'ಪರಿಶೀಲಿಸಿದ ಆಪರೇಟರ್‌ಗಳು',
    verifiedOperatorsDesc: 'ಎಲ್ಲಾ ಆಪರೇಟರ್‌ಗಳು AOC ಪ್ರಮಾಣಪತ್ರಗಳು, ವಿಮೆ ಮತ್ತು ಸುರಕ್ಷತಾ ಅನುಸರಣೆಯೊಂದಿಗೆ ಸಂಪೂರ್ಣವಾಗಿ ಪರಿಶೀಲಿಸಲ್ಪಟ್ಟಿದ್ದಾರೆ.',
    bestPrices: 'ಅತ್ಯುತ್ತಮ ಬೆಲೆಗಳು',
    bestPricesDesc: 'AI-ಚಾಲಿತ ಬೆಲೆ ಸಲಹೆಗಳು ಬಹು ಆಪರೇಟರ್‌ಗಳಿಂದ ಸ್ಪರ್ಧಾತ್ಮಕ ಕೊಟೇಶನ್‌ಗಳನ್ನು ಖಚಿತಪಡಿಸುತ್ತವೆ.',
    seamlessBooking: 'ಸುಲಭ ಬುಕಿಂಗ್',
    seamlessBookingDesc: 'ಕೊಟೇಶನ್ ವಿನಂತಿಯಿಂದ ಡಿಜಿಟಲ್ ಟಿಕೆಟ್‌ಗಳವರೆಗೆ, ನಿಮ್ಮ ಸಂಪೂರ್ಣ ಪ್ರಯಾಣವನ್ನು ಒಂದೇ ವೇದಿಕೆಯಲ್ಲಿ ನಿರ್ವಹಿಸಿ.',
    flightsCompleted: 'ಪೂರ್ಣಗೊಂಡ ವಿಮಾನಗಳು',
    verifiedOperatorsStat: 'ಪರಿಶೀಲಿಸಿದ ಆಪರೇಟರ್‌ಗಳು',
    safetyRecord: 'ಸುರಕ್ಷತಾ ದಾಖಲೆ',
    customerRating: 'ಗ್ರಾಹಕ ರೇಟಿಂಗ್',
    premiumServices: 'ಪ್ರೀಮಿಯಂ ಸೇವೆಗಳು',
    elevateExperience: 'ನಿಮ್ಮ ಅನುಭವವನ್ನು ಹೆಚ್ಚಿಸಿ',
    premiumSubtitle: 'ನಮ್ಮ ಪ್ರೀಮಿಯಂ ಸದಸ್ಯತ್ವ ಮತ್ತು ಕಾರ್ಪೊರೇಟ್ ಪ್ರಯಾಣ ಪರಿಹಾರಗಳೊಂದಿಗೆ ವಿಶೇಷ ಪ್ರಯೋಜನಗಳನ್ನು ಪಡೆಯಿರಿ',
    blackDesc: '20% ವರೆಗೆ ರಿಯಾಯಿತಿ, ಆದ್ಯತೆಯ ಬುಕಿಂಗ್, ಮೀಸಲಾದ ಪೈಲಟ್ ಮತ್ತು ವಿಶೇಷ ಲಾಂಜ್ ಪ್ರವೇಶದೊಂದಿಗೆ ಪ್ರೀಮಿಯಂ ಸದಸ್ಯತ್ವ.',
    priorityQueue: 'ಆದ್ಯತೆಯ ಬುಕಿಂಗ್ ಸರತಿ',
    dedicatedManager: 'ಮೀಸಲಾದ ರಿಲೇಶನ್‌ಶಿಪ್ ಮ್ಯಾನೇಜರ್',
    freeCancellation: 'ಉಚಿತ ರದ್ದತಿ',
    exploreMembership: 'ಸದಸ್ಯತ್ವ ನೋಡಿ',
    corporateConsole: 'ಕಾರ್ಪೊರೇಟ್ ಕನ್ಸೋಲ್',
    corporateDesc: 'ಅನುಮೋದನೆ ವರ್ಕ್‌ಫ್ಲೋಗಳು, ಬಜೆಟ್‌ಗಳು ಮತ್ತು ಏಕೀಕೃತ ಬಿಲ್ಲಿಂಗ್‌ನೊಂದಿಗೆ ಉದ್ಯಮಗಳಿಗೆ ಕೇಂದ್ರೀಕೃತ ಪ್ರಯಾಣ ನಿರ್ವಹಣೆ.',
    employeeManagement: 'ಉದ್ಯೋಗಿ ನಿರ್ವಹಣೆ',
    budgetControls: 'ಬಜೆಟ್ ನಿಯಂತ್ರಣಗಳು',
    travelAnalytics: 'ಪ್ರಯಾಣ ವಿಶ್ಲೇಷಣೆ',
    corporateRegistration: 'ಕಾರ್ಪೊರೇಟ್ ನೋಂದಣಿ',
    documentVault: 'ಡಾಕ್ಯುಮೆಂಟ್ ವಾಲ್ಟ್',
    vaultDesc: 'DGCA ದಾಖಲೆಗಳು, ವಿಮೆ, ಪರವಾನಗಿಗಳಿಗೆ ಸುರಕ್ಷಿತ ಎನ್‌ಕ್ರಿಪ್ಟ್ ಮಾಡಿದ ಸಂಗ್ರಹಣೆ - ಅವಧಿ ಮುಗಿಯುವ ಎಚ್ಚರಿಕೆಗಳು ಮತ್ತು ಆವೃತ್ತಿ ನಿಯಂತ್ರಣದೊಂದಿಗೆ.',
    encryption: 'AES-256 ಎನ್‌ಕ್ರಿಪ್ಶನ್',
    expiryReminders: 'ಅವಧಿ ಮುಗಿಯುವ ಜ್ಞಾಪನೆಗಳು',
    secureSharing: 'ಸುರಕ್ಷಿತ ಹಂಚಿಕೆ',
    openVault: 'ವಾಲ್ಟ್ ತೆರೆಯಿರಿ',
    loginToAccess: 'ಪ್ರವೇಶಕ್ಕೆ ಲಾಗಿನ್ ಮಾಡಿ',
    readyTakeOff: 'ಹಾರಲು ಸಿದ್ಧರಿದ್ದೀರಾ?',
    ctaSubtitle: 'ಇಂದೇ ನಿಮ್ಮ ಹೆಲಿಕಾಪ್ಟರ್ ಚಾರ್ಟರ್ ಅನ್ನು ಬುಕ್ ಮಾಡಿ ಮತ್ತು ವಾಯುಯಾನ ಶ್ರೇಷ್ಠತೆಯನ್ನು ಅನುಭವಿಸಿ.',
    startBooking: 'ಬುಕಿಂಗ್ ಪ್ರಾರಂಭಿಸಿ',
    footerText: '© 2025 AirYatra. ಎಲ್ಲಾ ಹಕ್ಕುಗಳನ್ನು ಕಾಯ್ದಿರಿಸಲಾಗಿದೆ. ಭಾರತದ ಪ್ರಮುಖ ಹೆಲಿಕಾಪ್ಟರ್ ಚಾರ್ಟರ್ ವೇದಿಕೆ.',
  },
  booking: {
    title: 'ನಿಮ್ಮ ವಿಮಾನವನ್ನು ಬುಕ್ ಮಾಡಿ',
    subtitle: 'AirYatra - ಪ್ರೀಮಿಯಂ ಏರ್ ಮೊಬಿಲಿಟಿ ಸೇವೆಗಳು',
    previous: 'ಹಿಂದಿನದು',
    next: 'ಮುಂದೆ',
    loginPrompt: 'ಬುಕಿಂಗ್ ವಿಚಾರಣೆಗೆ ದಯವಿಟ್ಟು ಲಾಗಿನ್ ಮಾಡಿ',
    loginBtn: 'ಲಾಗಿನ್',
    steps: {
      passengers: 'ಪ್ರಯಾಣಿಕರು',
      booking_type: 'ಬುಕಿಂಗ್ ಪ್ರಕಾರ',
      route: 'ಮಾರ್ಗ',
      price_inquiry: 'ಬೆಲೆ',
    },
  },
  bookingForm: {
    selectAircraftType: 'ವಿಮಾನದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    maxPassengers: 'ಗರಿಷ್ಠ {{count}} ಪ್ರಯಾಣಿಕರು',
    adultPassengers: 'ವಯಸ್ಕ ಪ್ರಯಾಣಿಕರು',
    male: 'ಪುರುಷ',
    female: 'ಮಹಿಳೆ',
    totalAdults: 'ಒಟ್ಟು ವಯಸ್ಕರು',
    children: 'ಮಕ್ಕಳು (4 ವರ್ಷದವರೆಗೆ)',
    childrenFree: 'ಉಚಿತ - ಗರಿಷ್ಠ 2 ಮಕ್ಕಳು',
    flightType: 'ವಿಮಾನದ ಪ್ರಕಾರ',
    selectOption: '-- ಆಯ್ಕೆಮಾಡಿ --',
    bookingFor: 'ಯಾರಿಗಾಗಿ ಬುಕಿಂಗ್',
    bookingPurpose: 'ಬುಕಿಂಗ್ ಉದ್ದೇಶ',
    selected: 'ಆಯ್ಕೆಮಾಡಲಾಗಿದೆ',
    specifyPurpose: 'ಉದ್ದೇಶವನ್ನು ತಿಳಿಸಿ',
    pickupLocation: 'ಪಿಕಪ್ ಸ್ಥಳ',
    selectPickupPoint: 'ಪಿಕಪ್ ಪಾಯಿಂಟ್ ಆಯ್ಕೆಮಾಡಿ',
    dropLocation: 'ಡ್ರಾಪ್ ಸ್ಥಳ',
    selectDropPoint: 'ಡ್ರಾಪ್ ಪಾಯಿಂಟ್ ಆಯ್ಕೆಮಾಡಿ',
    estimatedDistance: 'ಅಂದಾಜು ದೂರ',
    villageDocsTitle: 'ಗ್ರಾಮ ಲ್ಯಾಂಡಿಂಗ್ - ದಾಖಲೆಗಳು ಅಗತ್ಯ',
    villageDocsDesc: 'ಗ್ರಾಮ/ಖಾಸಗಿ ಭೂಮಿಯಲ್ಲಿ ಇಳಿಯಲು, ನೀವು ಅಧಿಕಾರಿಗಳಿಂದ ಈ ಕೆಳಗಿನ ದಾಖಲೆಗಳನ್ನು ಪಡೆಯಬೇಕು:',
    villageDocsNote: 'ಬುಕಿಂಗ್ ದೃಢೀಕರಿಸಿದ ನಂತರ, ನೀವು ಈ ದಾಖಲೆಗಳನ್ನು ಅಪ್‌ಲೋಡ್ ಮಾಡಬೇಕು. Admin/Operator ಪರಿಶೀಲಿಸಿದ ನಂತರವೇ ಪೈಲಟ್ ಹಾರುತ್ತಾರೆ.',
    departureDate: 'ನಿರ್ಗಮನ ದಿನಾಂಕ',
    pickupTime: 'ಪಿಕಪ್ ಸಮಯ',
    additionalOptions: 'ಹೆಚ್ಚುವರಿ ಆಯ್ಕೆಗಳು (ಐಚ್ಛಿಕ)',
    waitingTime: 'ಕಾಯುವ ಸಮಯ (ನಿಮಿಷಗಳು)',
    waitingTimeNote: 'ಮೊದಲ 30 ನಿಮಿಷ ಉಚಿತ, ನಂತರ ಶುಲ್ಕ ಅನ್ವಯ',
    nightHalts: 'ರಾತ್ರಿ ತಂಗುವಿಕೆ',
    nightHaltsNote: 'ಸಿಬ್ಬಂದಿ ವಸತಿ ಶುಲ್ಕ ಸೇರಿದೆ',
    bookingSummary: 'ಬುಕಿಂಗ್ ಸಾರಾಂಶ',
    aircraftTypeLabel: 'ವಿಮಾನ ಪ್ರಕಾರ:',
    totalPassengersLabel: 'ಒಟ್ಟು ಪ್ರಯಾಣಿಕರು:',
    adults: 'ವಯಸ್ಕರು',
    childrenLabel: 'ಮಕ್ಕಳು',
    flightTypeLabel: 'ವಿಮಾನ ಪ್ರಕಾರ:',
    pickupLabel: 'ಪಿಕಪ್:',
    dropLabel: 'ಡ್ರಾಪ್:',
    distanceLabel: 'ದೂರ:',
    dateTimeLabel: 'ದಿನಾಂಕ ಮತ್ತು ಸಮಯ:',
    at: 'ಕ್ಕೆ',
    villageApprovalTitle: 'ಗ್ರಾಮ ಲ್ಯಾಂಡಿಂಗ್ - ಅಡ್ಮಿನ್ ಅನುಮೋದನೆ ಅಗತ್ಯ',
    villageApprovalDesc: 'ನಿಮ್ಮ ವಿಚಾರಣೆಯನ್ನು ಅಡ್ಮಿನ್ ಅನುಮೋದನೆಗೆ ಸಲ್ಲಿಸಲಾಗುತ್ತದೆ. ಅನುಮೋದನೆಯ ನಂತರ ಪಾವತಿ ಸಕ್ರಿಯಗೊಳ್ಳುತ್ತದೆ.',
    priceBreakdown: 'ಬೆಲೆ ವಿವರ',
    baseFlightCost: 'ಮೂಲ ವಿಮಾನ ವೆಚ್ಚ',
    flightCost: 'ವಿಮಾನ ವೆಚ್ಚ',
    positioningCost: 'ಪೊಸಿಷನಿಂಗ್ ವೆಚ್ಚ (ಡೆಡ್-ಲೆಗ್)',
    roundTripDiscount: 'ರೌಂಡ್ ಟ್ರಿಪ್ ರಿಯಾಯಿತಿ',
    operatorGrossCost: 'ಆಪರೇಟರ್ ಒಟ್ಟು ವೆಚ್ಚ',
    additionalCharges: 'ಹೆಚ್ಚುವರಿ ಶುಲ್ಕಗಳು',
    waitingGroundHolding: 'ಕಾಯುವಿಕೆ / ಗ್ರೌಂಡ್ ಹೋಲ್ಡಿಂಗ್',
    nightHalt: 'ರಾತ್ರಿ ತಂಗುವಿಕೆ ({{count}} ರಾತ್ರಿಗಳು)',
    crewAccommodation: 'ಸಿಬ್ಬಂದಿ ವಸತಿ ಮತ್ತು ಆಹಾರ',
    fuelSurcharge: 'ಇಂಧನ ಸರ್ಚಾರ್ಜ್',
    platformFees: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಶುಲ್ಕಗಳು',
    convenienceFee: 'ಅನುಕೂಲ ಶುಲ್ಕ',
    insurance: 'ವಿಮೆ',
    peakSurge: 'ಪೀಕ್ ಸೀಸನ್ ಸರ್ಜ್',
    platformCommission: 'ಪ್ಲಾಟ್‌ಫಾರ್ಮ್ ಕಮಿಷನ್',
    included: 'ಸೇರಿದೆ',
    helipadCharges: 'ಹೆಲಿಪ್ಯಾಡ್ ಲ್ಯಾಂಡಿಂಗ್ ಶುಲ್ಕಗಳು',
    totalLandingCharges: 'ಒಟ್ಟು ಲ್ಯಾಂಡಿಂಗ್ ಶುಲ್ಕಗಳು',
    taxableAmount: 'ತೆರಿಗೆ ವಿಧಿಸಬಹುದಾದ ಮೊತ್ತ',
    totalGst: 'ಒಟ್ಟು GST',
    grandTotal: 'ಒಟ್ಟು ಮೊತ್ತ',
    inclusiveTaxes: 'ಎಲ್ಲಾ ತೆರಿಗೆಗಳು ಸೇರಿದಂತೆ',
    operatorReceives: 'ಆಪರೇಟರ್ ಪಡೆಯುತ್ತಾರೆ',
    specialRequirements: 'ವಿಶೇಷ ಅವಶ್ಯಕತೆಗಳು (ಐಚ್ಛಿಕ)',
    specialRequirementsPlaceholder: 'ಯಾವುದೇ ವಿಶೇಷ ವಿನಂತಿಗಳು ಅಥವಾ ಅವಶ್ಯಕತೆಗಳು...',
    submitting: 'ಸಲ್ಲಿಸಲಾಗುತ್ತಿದೆ...',
    submitApproval: 'ಅನುಮೋದನೆಗೆ ಸಲ್ಲಿಸಿ',
    generateInquiry: 'ವಿಚಾರಣೆ ಕಳುಹಿಸಿ',
    approvalNote: 'ಗ್ರಾಮ ಲ್ಯಾಂಡಿಂಗ್‌ಗೆ ಅಡ್ಮಿನ್ ಅನುಮೋದನೆ ಅಗತ್ಯ.',
    inquiryNote: 'ವಿಚಾರಣೆಯ ನಂತರ, ಆಪರೇಟರ್‌ಗಳು ನಿಮಗೆ ಕೊಟೇಶನ್‌ಗಳನ್ನು ಕಳುಹಿಸುತ್ತಾರೆ.',
    formRestored: 'ಫಾರ್ಮ್ ಡೇಟಾ ಮರುಸ್ಥಾಪಿಸಲಾಗಿದೆ!',
    selectAircraftError: 'ದಯವಿಟ್ಟು ವಿಮಾನದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    minAdultError: 'ಕನಿಷ್ಠ 1 ವಯಸ್ಕ ಪ್ರಯಾಣಿಕ ಅಗತ್ಯ',
    maxChildrenError: 'ಗರಿಷ್ಠ 2 ಮಕ್ಕಳಿಗೆ ಅನುಮತಿ',
    selectFlightTypeError: 'ದಯವಿಟ್ಟು ವಿಮಾನದ ಪ್ರಕಾರವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectBookingForError: 'ಯಾರಿಗಾಗಿ ಬುಕಿಂಗ್ ಎಂಬುದನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectPurposeError: 'ಬುಕಿಂಗ್ ಉದ್ದೇಶವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectPickupError: 'ಪಿಕಪ್ ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectDropError: 'ಡ್ರಾಪ್ ಸ್ಥಳವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectDateError: 'ನಿರ್ಗಮನ ದಿನಾಂಕವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    selectTimeError: 'ಪಿಕಪ್ ಸಮಯವನ್ನು ಆಯ್ಕೆಮಾಡಿ',
    priceWaitError: 'ಬೆಲೆ ಲೆಕ್ಕಹಾಕಲಾಗಿಲ್ಲ! ದಯವಿಟ್ಟು ಕಾಯಿರಿ',
    inquirySubmitted: 'ವಿಚಾರಣೆ ಸಲ್ಲಿಸಲಾಗಿದೆ! ಆಪರೇಟರ್‌ಗಳು ಶೀಘ್ರದಲ್ಲೇ ಪ್ರತಿಕ್ರಿಯಿಸುತ್ತಾರೆ',
    noteVillageApproval: 'ಗ್ರಾಮ ಲ್ಯಾಂಡಿಂಗ್‌ಗೆ ಅಡ್ಮಿನ್ ಅನುಮೋದನೆ ಅಗತ್ಯ',
    notePriceEngine: 'ಏವಿಯೇಷನ್-ಗ್ರೇಡ್ ಪ್ರೈಸಿಂಗ್ ಎಂಜಿನ್ ಮೂಲಕ ಲೆಕ್ಕಹಾಕಲಾಗಿದೆ',
    noteFinalPrice: 'ಅಂತಿಮ ಬೆಲೆಯನ್ನು ಆಪರೇಟರ್ ದೃಢೀಕರಿಸುತ್ತಾರೆ',
    docCollectorNoc: 'ಕಲೆಕ್ಟರ್ NOC',
    docFireDept: 'ಅಗ್ನಿಶಾಮಕ ಇಲಾಖೆ ಸ್ವೀಕೃತಿ',
    docPoliceStation: 'ಸ್ಥಳೀಯ ಪೊಲೀಸ್ ಠಾಣೆ ಸ್ವೀಕೃತಿ',
    docSpDcp: 'SP/DCP ಸ್ವೀಕೃತಿ',
  },
  options: {
    helicopter: 'ಹೆಲಿಕಾಪ್ಟರ್',
    chartered_plane: 'ಚಾರ್ಟರ್ಡ್ ವಿಮಾನ',
    one_hour: '1 ಗಂಟೆಯ ಹಾರಾಟ',
    two_hour: '2 ಗಂಟೆಗಳ ಹಾರಾಟ',
    half_day: 'ಅರ್ಧ ದಿನ',
    full_day: 'ಪೂರ್ಣ ದಿನ',
    multi_city: 'ಬಹು-ನಗರ',
    point_to_point: 'ಪಾಯಿಂಟ್-ಟು-ಪಾಯಿಂಟ್',
    self: 'ನನಗಾಗಿ',
    friend_family: 'ಸ್ನೇಹಿತರು ಮತ್ತು ಕುಟುಂಬ',
    company: 'ಕಂಪನಿ / ಕಾರ್ಪೊರೇಟ್',
    political: 'ರಾಜಕೀಯ / VIP',
    other: 'ಇತರೆ',
    wedding: 'ಮದುವೆ',
    temple_yatra: 'ದೇವಾಲಯ ಯಾತ್ರೆ',
    company_tour: 'ಕಾರ್ಪೊರೇಟ್ ಪ್ರವಾಸ',
    election_tour: 'ಚುನಾವಣಾ ಪ್ರಚಾರ',
    medical_emergency: 'ವೈದ್ಯಕೀಯ ತುರ್ತು',
    film_shooting: 'ಚಲನಚಿತ್ರ ಚಿತ್ರೀಕರಣ',
    general_tour: 'ಸಾಮಾನ್ಯ ಪ್ರವಾಸ',
    pilgrimage: 'ತೀರ್ಥಯಾತ್ರೆ',
    business: 'ವ್ಯಾಪಾರ ಸಭೆ',
  },
};

export default kn;
